import React from 'react';

const ReusableModal = ({ isOpen, title, onClose, children, footer }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50 p-4">
      
      <div
        className="
          bg-white rounded-lg shadow-xl flex flex-col p-6
          
          /* Mobile first */
          w-full 
          max-w-full 
          max-h-[95vh]
          overflow-hidden

          /* Tablet */
          md:w-[80%]

          /* Desktop */
          lg:w-[80%]
          lg:max-w-5xl
        "
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl lg:text-2xl font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-red-500 text-2xl leading-none"
          >
            &times;
          </button>
        </div>

        {/* Contenido scrollable */}
        <div className="flex-1 overflow-y-auto pr-1">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="pt-4 border-t mt-4">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReusableModal;
